import { useTranslation } from 'react-i18next';
import StatusLabel from '../../Fundamentals/Label/StatusLabel';
import type { StatusLabelVariant } from '../../Fundamentals/Label/StatusLabel';
import { VossScheduledChangeStatus, VossScheduledChangeStatusText } from '../../../Constants/VOSS/vossScheduledChangeStatus';

// VSCO-3791: Pending blue, Completed green, Cancelled grey
const STATUS_STYLES: Record<VossScheduledChangeStatus, { variant: StatusLabelVariant; disabled: boolean }> = {
    [VossScheduledChangeStatus.Pending]: { variant: 'info', disabled: false },
    [VossScheduledChangeStatus.CompletedForUpcomingPeriod]: { variant: 'success', disabled: false },
    [VossScheduledChangeStatus.Completed]: { variant: 'success', disabled: false },
    [VossScheduledChangeStatus.Cancelled]: { variant: 'default', disabled: true },
};

interface ScheduledChangeStatusBadgeProps {
    status: VossScheduledChangeStatus | undefined;
}

const ScheduledChangeStatusBadge = ({ status }: ScheduledChangeStatusBadgeProps) => {
    const { t } = useTranslation();

    const style = status === undefined ? undefined : STATUS_STYLES[status];
    if (style === undefined || status === undefined) return null;

    return (
        <StatusLabel variant={style.variant} disabled={style.disabled}>
            {t(VossScheduledChangeStatusText[status])}
        </StatusLabel>
    );
};

export default ScheduledChangeStatusBadge;
